module.exports = __webpack_public_path__ + "static/img/spray_1.098eef2b.png";